
// vue
import { ref, defineComponent, PropType, onMounted } from 'vue';
import { useRoute } from 'vue-router';

// firebase
import 'firebase/firestore';
import { db, serverTimestamp } from '@/main';

// atoms
import CustomButton from '@/components/atoms/CustomButton.vue';
import Heading from '@/components/atoms/Heading.vue';
import Modal from '@/components/atoms/Modal.vue';
import TextField from '@/components/atoms/TextField.vue';

// utlis
import { getRoomId, calcDiffTimeFromNow } from '@/utils';

// types
import { RoomDoc } from '@/types';

export default defineComponent({
  name: 'CreateRoomWindow',
  components: {
    CustomButton,
    Heading,
    Modal,
    TextField,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    roomObj: {
      type: Object as PropType<RoomDoc>,
      required: true,
    },
  },
  emits: ['close'],
  setup(props) {
    const route = useRoute();

    // ルームの有効期限
    const expirationDate = ref('1');
    const calcExpirationDay = () => {
      if (!props.roomObj.createdAt) return 0;

      const dt = props.roomObj.createdAt.toDate();
      dt.setDate(dt.getDate() + props.roomObj.expirationDate);
      const diff = calcDiffTimeFromNow(dt, 'future');
      return diff;
    };

    // 勉強会タイトル
    const roomTitleRef = ref(null);
    const isRoomTitleEditMode = ref(false);

    // 受講者人数
    const studentNum = ref(1);
    const studentNumRef = ref(null);
    const isStudentNumEditMode = ref(false);

    // 受講者 & 管理画面URL
    const url = location.href.replace(/\?+/, '');
    const studentScreenURL = ref(url.replace('admin', 'student'));
    const managedScreenURL = ref(url);
    const showShareManagedMsg = ref(false);
    onMounted(() => {
      setTimeout(() => {
        // 共有用管理画面URL作成
        const roomPass = props?.roomObj?.roomPassword;
        if (roomPass) {
          managedScreenURL.value += `?p=${roomPass}`;
          showShareManagedMsg.value = true;
        }
      }, 1000);
    });

    // 項目修正
    const editItem = (itemKey: string) => {
      if (itemKey === 'roomTitle') {
        isRoomTitleEditMode.value = true;
        // inputにfocusさせる
        setTimeout(() => {
          // @ts-ignore
          roomTitleRef.value.focusInput();
        }, 10);
      } else if (itemKey === 'studentNum') {
        isStudentNumEditMode.value = true;
        // inputにfocusさせる
        setTimeout(() => {
          // @ts-ignore
          studentNumRef.value.focusInput();
        }, 10);
      }
    };
    const saveItem = async (itemKey: string) => {
      const updateObj = {} as RoomDoc;
      if (itemKey === 'roomTitle') {
        isRoomTitleEditMode.value = false;
        updateObj.roomTitle = props.roomObj.roomTitle;
      } else if (itemKey === 'studentNum') {
        updateObj.studentNum = props.roomObj.studentNum;
      }
      // @ts-ignore
      updateObj.updatedAt = serverTimestamp();

      const id = getRoomId(route);

      try {
        await db.collection('Room').doc(id).update(updateObj);
      } catch (e) {
        console.error(e);
      }
      isRoomTitleEditMode.value = false;
      isStudentNumEditMode.value = false;
    };

    const endEditMode = () => {
      isRoomTitleEditMode.value = false;
      isStudentNumEditMode.value = false;
    };

    return {
      studentScreenURL,
      managedScreenURL,
      showShareManagedMsg,
      studentNum,
      expirationDate,
      calcExpirationDay,
      editItem,
      saveItem,
      isRoomTitleEditMode,
      isStudentNumEditMode,
      roomTitleRef,
      studentNumRef,
      endEditMode,
    };
  },
});
